// Canonical Mundely map foundation. Shared by trip, public link and standalone export.
// CARTO Voyager currently returns API KEY REQUIRED images; do not restore it blindly.
// Geographic base maps belong here; consumers must never add coastline overlays.
export const STREET_TILES = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
export const STREET_OPTIONS = {
  maxZoom: 19,
  attribution: 'Tiles &copy; <a href="https://goto.arcgisonline.com/maps/World_Street_Map" target="_blank" rel="noopener noreferrer">Esri and data providers</a>'
};
export const SATELLITE_TILES = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
export function createMapBaseLayers(L: any) {
  return {
    classic: L.tileLayer(STREET_TILES, { ...STREET_OPTIONS, updateWhenIdle: true, keepBuffer: 2 }),
    satellite: L.tileLayer(SATELLITE_TILES, { maxZoom: 19, attribution: 'Tiles &copy; Esri', keepBuffer: 4 })
  };
}
// The world status map keeps interactive country fills, without outline strokes.
export const COUNTRY_FILL_STYLE = { stroke: false, weight: 0, opacity: 0 } as const;

/** Screen-pixel offsets only. Coordinates used by navigation are never changed. */
export function spreadMarkerPositions<T>(map: any, points: T[], position: (point: T) => readonly number[]) {
  const projected = points.map(point => ({ point, real: position(point), pixel: map.latLngToLayerPoint(position(point)) }));
  const groups: typeof projected[] = [];
  for (const item of projected) {
    const group = groups.find(items => Math.hypot(items[0].pixel.x - item.pixel.x, items[0].pixel.y - item.pixel.y) < 34);
    if (group) group.push(item); else groups.push([item]);
  }
  return groups.flatMap(group => group.map((item, index) => {
    const angle = -Math.PI / 2 + index * Math.PI * 2 / group.length, radius = group.length > 1 ? 32 : 0;
    const target = map.layerPointToLatLng({ x: item.pixel.x + Math.cos(angle) * radius, y: item.pixel.y + Math.sin(angle) * radius });
    return { point: item.point, real: [item.real[0], item.real[1]] as [number, number], display: [target.lat, target.lng] as [number, number], shifted: radius > 0 };
  }));
}
/** The sole permitted map overlay: one marker to its own real position, at most 42px. */
export function addMapMarkerLeader(L: any, map: any, real: readonly number[], display: readonly number[], group: any) {
  const start = map.latLngToLayerPoint(real), end = map.latLngToLayerPoint(display);
  const pixels = Math.hypot(start.x - end.x, start.y - end.y);
  if (!Number.isFinite(pixels) || pixels < 1 || pixels > 42) return null;
  return L.polyline([real, display], { color: "#124848", weight: 1.5, opacity: .75, dashArray: "3 4", interactive: false, className: "mundely-marker-leader" }).addTo(group);
}
